import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PureLife from "@/pages/PureLife";
import RulesPage from "@/pages/RulesPage";
import CustomCursor from "@/components/CustomCursor";
import { AuthProvider } from "@/admin/AuthContext";
import { SiteContentProvider } from "@/admin/SiteContent";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminOverview from "@/admin/AdminOverview";
import ProtectedRoute from "@/admin/ProtectedRoute";
import {
  HeroEditor,
  LoreEditor,
  LinksEditor,
  CharacterEditor,
  FactionsEditor,
  FeaturesEditor,
  GalleryEditor,
  RulesEditor,
  RulesMetaEditor,
  UniverseEditor,
} from "@/admin/Editors";
import UsersManager from "@/admin/UsersManager";
import MediaLibrary from "@/admin/MediaLibrary";
import { BibleEditor } from "@/admin/BibleEditor";
import StaffLogin from "@/staff/StaffLogin";
import StaffBible from "@/staff/StaffBible";
import StaffProtectedRoute from "@/staff/StaffProtectedRoute";

function App() {
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    remove();
    const interval = setInterval(remove, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <CustomCursor />
      <BrowserRouter>
        <SiteContentProvider>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<PureLife />} />
              <Route path="/regolamento" element={<RulesPage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminOverview />} />
                <Route path="hero" element={<HeroEditor />} />
                <Route path="lore" element={<LoreEditor />} />
                <Route path="universe" element={<UniverseEditor />} />
                <Route path="factions" element={<FactionsEditor />} />
                <Route path="features" element={<FeaturesEditor />} />
                <Route path="chapters" element={<RulesEditor />} />
                <Route path="rules-meta" element={<RulesMetaEditor />} />
                <Route path="gallery" element={<GalleryEditor />} />
                <Route path="character" element={<CharacterEditor />} />
                <Route path="media" element={<MediaLibrary />} />
                <Route path="links" element={<LinksEditor />} />
                <Route path="bible" element={<BibleEditor />} />
                <Route
                  path="users"
                  element={
                    <ProtectedRoute requireOwner>
                      <UsersManager />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Staff Vault — separate URL, hidden from public navigation */}
              <Route path="/staff/login" element={<StaffLogin />} />
              <Route
                path="/staff"
                element={<Navigate to="/staff/bible" replace />}
              />
              <Route
                path="/staff/bible"
                element={
                  <StaffProtectedRoute>
                    <StaffBible />
                  </StaffProtectedRoute>
                }
              />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </SiteContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
